import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  padding-top: 200px;

  ${media.tablet} {
    padding: 200px ${OFFSET.M} 0;
  }
`;

export const ListContainer = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${OFFSET.S};
  padding: 0 ${OFFSET.S};

  ${media.mobile} {
    grid-template-columns: repeat(3, 1fr);
    gap: ${OFFSET.M};
    padding: 0;
  }

  ${media.tablet} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const HiddenBottom = styled.div`
  height: 20px;
  width: 100%;
  background-color: transparent;
`;

export const imageStyles = css`
  height: calc(50vw - 40px);
  max-width: 100%;

  ${media.tablet} {
    height: calc(33.333vw - 40px - 15px);
  }
`;
